<template>
    <v-dialog
        v-model="visible"
        :show="true"
        persistent
        :max-width="510"
        overlay-color="#2c2c38"
        :overlay-opacity="0.8"
    >
        <v-card v-if="notification" class="notification">
            <v-card-title class="notification-heading" :class="notification.type === 'info' ? 'primary' : notification.type">

                <!-- Invoice Generated Notification -->
                <span v-if="notification.code === 'invoice_generated'">
                    {{ $t('notification.invoice_generated_heading', { month: getMonth(notification.data.month) }) }}
                </span>

                <span v-else-if="notification.code">{{ $t(`notification.${notification.code}_heading`) }}</span>
                <span v-else>{{ $t('notification.heading') }}</span>
            </v-card-title>

            <v-card-text class="notification-content">
                <v-alert
                    class="notification-alert"
                    prominent
                    :color="notification.type === 'info' ? 'primary' : notification.type"
                    :type="notification.type"
                    text
                >
                    <!-- Invoice Generated Notification -->
                    <template v-if="notification.code === 'invoice_generated'">
                        <span>
                            {{ $t('notification.invoice_generated', {
                                software: isAllegra ? 'Allegra' : 'Aria',
                                amount: Money.parse(notification.data.amount).toFormat(),
                                month: getMonth(notification.data.month)
                            }) }}
                        </span>
                        <div class="mt-2">{{ $t('notification.invoice_generated_check') }}</div>
                    </template>

                    <template v-else-if="notification.code">
                        {{ $t(`notification.${notification.code}`) }}
                    </template>

                    <span v-else>
                        {{ notification.text }}
                    </span>
                </v-alert>

                <div class="flex justify-center mt-6 mb-1">
                    <v-btn
                        class="white--text"
                        :color="notification.type === 'info' ? 'primary' : notification.type"
                        depressed
                        large
                        @click="hide()"
                    >
                        {{ $t('general.close') }}
                    </v-btn>
                </div>
            </v-card-text>
        </v-card>

    </v-dialog>
</template>

<script>
export default {
    created() {
        this.eventBus.$on('show-notification', this.showNotification);
    },

    beforeDestroy() {
        this.eventBus.$off('show-notification', this.showNotification);
    },

    data() {
        return {
            visible: false,
            notification: null
        };
    },

    methods: {
        showNotification(data) {
            this.notification = data.notification;
            this.visible = true;
        },

        hide() {
            this.markAsSeen()
            this.notification = null
            this.visible = false;
        },

        markAsSeen() {
            if(this.impersonate) return
            this.notification.markAsRead()
        },

        getMonth(month) {
            return this.$t(`months.${moment(month, 'MM/YYYY').format('MMMM').toLowerCase()}`) +
                ` ${moment(month, 'MM/YYYY').format('YYYY')}.`
        }
    }
};
</script>

<style lang="scss" scoped>
.notification {
    display: flex;
    flex-direction: column;

    .notification-heading {
        color: white;
        justify-content: center;
        font-weight: 400;
        font-size: 22px;
        padding: 12px;
    }

    .notification-content {
        padding: 24px;

        .notification-alert {
            color: black !important;
            border: 1px solid #e8e8e8;

            &:before {
                background: #cccccc !important;
            }
        }
    }
}
</style>
